import React, { useContext } from 'react'
import urls from '../../../utils/constants/urls'
import Grid from '../../elem/grid/display/Grid'
import PageLayout from '../../elem/Layout'
import { DataContext } from './DataContext'

const BidPackages = () => {
    const { listMetadata, updateQueryParameters, queryParameters, bidPackages, loading, gridConfig, gridConfigExpanded, createLink } = useContext(DataContext)

    return (
        <PageLayout returnUrl={urls.home}>
                <Grid
                    metaData={listMetadata}
                    updateQueryParameters={updateQueryParameters}
                    queryParameters={queryParameters}
                    data={bidPackages}
                    gridConfig={gridConfig}
                    name={'bidPackages'}
                    loading={loading}
                    gridConfigExpanded={gridConfigExpanded}
                    createLink={createLink}
                />
        </PageLayout>
    )
}

export default BidPackages
